import { useLayoutEffect } from 'react';

import { useMixpanel } from './useMixpanel';

export function useMixpanelTrack(name: string | undefined) {
	const mixpanel = useMixpanel();

	useLayoutEffect(() => {
		if (name) {
			mixpanel?.track(name);
		}
	}, [name, !!mixpanel]);
}
